import React from 'react'
import cx from 'classnames'

import { LoaderRow } from 'components/shared/Table/common/LoaderRow/LoaderRow'
import { PlaceholderRow } from 'components/shared/Table/common/PlaceholderRow/PlaceholderRow'

import styles from './TableBody.module.scss'

type TableBodyProps = {
  children?: React.ReactNode
  className?: string
  placeholder?: { title?: React.ReactNode; text?: string }
  isLoaded?: boolean
}

export const TableBody = ({
  children,
  className,
  placeholder,
  isLoaded,
}: TableBodyProps) => {
  // Only an array or a string has a length, so a single child element counts as
  // no children here.
  const hasChildren =
    (Array.isArray(children) || typeof children === 'string') &&
    children.length > 0

  return (
    <tbody className={cx(styles.body, className)}>
      {!isLoaded && <LoaderRow />}
      {isLoaded && !hasChildren && <PlaceholderRow placeholder={placeholder} />}
      {isLoaded && hasChildren && children}
    </tbody>
  )
}
